// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2quMB","label":"Section_label__qn2oY","contentWrap":"Section_contentWrap__1clUb","footer":"Section_footer__3gZ8O","footerInner":"Section_footerInner__2ThY3"};